const InscriptionType = {
  oneLine: '0',
  twoLines: '1',
  none: '2'
};

export default InscriptionType;



// WEBPACK FOOTER //
// ./src/constants/inscription-type.js